<span (click)="openDetailCandidate()"
      class="cursor-pointer text-action">
  Voir plus
</span>
<span class="cursor-pointer text-action" style="margin-left: 15px;" (click)="editCandidate()">
  Modifier
</span>
<span class="chat-icon-wrapper" *ngIf="isChatActive" style="margin-left: 15px;" matTooltip="Envoyer un message au candidat" (click)="openMessageDialog($event)">
  <mat-icon class="chat-icon">chat_bubble</mat-icon>
</span>

